import React from 'react';
import {
  Callout,
  CalloutSemanticEnum,
  Link,
  RichText,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import type { BannerResult } from './types';
import styles from './AcquisitionBanner.module.scss';

interface AcquisitionBannerProps {
  banner: BannerResult;
}

const semanticMap = {
  warning: CalloutSemanticEnum.WARNING,
  info: CalloutSemanticEnum.INFORMATION,
};

const AcquisitionBanner: React.FC<AcquisitionBannerProps> = ({ banner }) => {
  const { severity, heading, description, linkUrl, rawHtml } = banner;
  const body = rawHtml ? (
    <RichText
      component={TypographyComponentEnum.SPAN}
      variant={TypographyVariant.body.medium}
      className={styles.acquisitionBannerRichText}
    >
      {description}
    </RichText>
  ) : (
    description
  );

  return (
    <Callout
      semantic={semanticMap[severity]}
      title={heading}
      data-testid="acquisition-banner"
      className={styles.acquisitionBannerRichText}
    >
      {linkUrl ? (
        <Link
          href={linkUrl}
          data-testid="acquisition-banner-link"
          className={styles.acquisitionBannerRichTextLink}
        >
          {body}
        </Link>
      ) : (
        body
      )}
    </Callout>
  );
};

export default AcquisitionBanner;
